export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12043.42f36211.jpg";